<template>
  <b-modal
    id="modal-preview-news"
    v-model="isShow"
    size="xxlg"
    :ok-only="true"
    ok-title="Đóng"
    hide-header
    hide-footer
    centered
    body-class="master-layout p-0"
    @hidden="close"
  >
    <ArticleView
      :article-id="articleId"
      :show-relate="false"
      :show-back="true"
      :show-close="true"
      @close-modal="close"
      @on-view-article="onViewArticle"
      @on-read-article="onReadArticle"
    />
  </b-modal>
</template>

<script>
export default {
  name: 'ViewPopup',
  components: {
    ArticleView: () => import(/* webpackPrefetch: true */ './View.vue'),
  },
  props: {
    articleId: {
      type: Number,
      default: 0,
    },
    showPreview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isShow: {
      get() {
        return this.showPreview
      },
      set(val) { },
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onViewArticle() {
      this.$emit('on-view-article', this.articleId);
    },
    onReadArticle() {
      this.$emit('on-read-article', this.articleId);
    },
  },
}
</script>
<style lang="scss"></style>
